import React from 'react';
import { OrnamentDivider } from './SectionDivider';
export function HookSection() {
  return <section className="w-full py-5 px-6" style={{
    background: 'var(--cream)'
  }} aria-label="El gancho" data-id="element-210">
      <div className="max-w-3xl mx-auto" data-id="element-211">
        <OrnamentDivider data-id="element-212" />

        <div className="flex flex-col gap-6 mt-[10px]" data-id="element-213">
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-214">
            Son las 10 de la noche antes del cumpleaños de tu hijo.
          </p>
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-215">
            Tienes la cocina llena de ingredientes. Seguiste cada paso de esa
            receta de Pinterest que tenía 500 comentarios positivos. Esperaste
            40 minutos frente al horno con el corazón esperanzado.
          </p>
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-216">
            Lo sacas. Lo cortas.
          </p>

          {/* Dramatic moment */}
          <div className="rounded-2xl p-8 my-4" style={{
          background: 'var(--cream-dark)',
          borderLeft: '4px solid var(--blush)'
        }} data-id="element-217">
            <p className="text-xl italic leading-relaxed" style={{
            color: 'var(--brown)',
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.35rem'
          }} data-id="element-218">
              Y lo que tienes enfrente parece adobe húmedo con sabor a cacao
              medicinal.
            </p>
          </div>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-219">
            No es la primera vez. Y lo peor no es el dinero gastado en
            ingredientes. Lo peor es esa cara de tu hijo cuando llega a la
            fiesta y no puede comer lo que todos están comiendo.
          </p>
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-220">
            O esa sensación tuya — después de un día perfecto de alimentación
            limpia — de terminar comiendo un postre que sabe a castigo y
            preguntarte si realmente vale la pena tanto esfuerzo.
          </p>

          {/* Empathy statement */}
          <div className="text-center py-6 pb-[5px]" data-id="element-221">
            <p className="text-2xl font-bold" style={{
            color: 'var(--brown)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-222">
              Yo sé exactamente cómo se siente eso.
            </p>
            <p className="text-xl mt-3 italic" style={{
            color: 'var(--gold-dark)',
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.3rem'
          }} data-id="element-223">
              Y también sé algo que lo cambia todo.
            </p>
          </div>
        </div>

        <OrnamentDivider className="mt-6" data-id="element-224" />
      </div>
    </section>;
}